import { IconButton, withStyles } from "@material-ui/core";
import React, {Component} from "react";
import { withRouter } from "react-router-dom";
import {Auth} from "aws-amplify";
import personIcon from "../../assets/images/header-person-icon.png";


const CustomButton = withStyles({
  root: {
    "&:hover": {
      backgroundColor: "#888",
    },
  },
})(IconButton);

const handleLogout = async () => {
  await Auth.signOut();
}

const Account = () => {
    return <div className="account" onClick={handleLogout}>
        <CustomButton className="person-button" variant="primary" >
            <img src={personIcon} alt="person icon"/>
        </CustomButton>
    </div>
}

export default Account;